export default __webpack_public_path__ + "static/media/FB.6a8eacaf.svg";